import Base from './base'
import renderFields from './qrcode.pug'

export default class Qrcode extends Base
  @label: "QR 條碼符合"

  renderFields: renderFields
